<template>
  <el-tabs ref='titleBadge' v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane name="task">  
      <span slot="label">  
      任务详情
      </span>  
      <RunCenterTask v-if="activeName === 'task'" ref="task"></RunCenterTask>
    </el-tab-pane> 
    <el-tab-pane name="diagram">  
      <span slot="label">  
      运行图
      </span>  
      <RunCenterDiagram v-if="activeName === 'diagram'" ref="diagram"></RunCenterDiagram>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import RunCenterTask from "./RunCenterTask";
  import RunCenterDiagram from "./RunCenterDiagram";

  export default {
    components: {
      RunCenterTask,
      RunCenterDiagram
    },
    data() {
      return {
        activeName: 'task'
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      }
    }
  };
</script>